import React from 'react'
import { getGlobal } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { useEffect, useMemo, useRef, useState } from "react";
import { Skeleton } from "antd";
import { StrapiError } from '../../Inicio/Pages/StrapiError';

/**
 * Pagination component
 * 
 * @param {number} currentPage 
 * @param {number} totalPages 
 * @param {number} rowCount 
 * @param {function} onPageChange 
 * @param {function} onRowCountChange 
 */
const Pagination = ({ currentPage, totalPages, rowCount, onPageChange, onRowCountChange }) => {
    const { locale } = useLocale();
    const [globalSetting, setGlobalSetting] = useState(null);
    const [isLoadingContent, setIsLoadingContent] = useState(true);
    const [hasError, setHasError] = useState(false);
    const handlePrevious = () => {
        if (currentPage > 1) onPageChange(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) onPageChange(currentPage + 1);
    };

    const handleChangeRowCount = (e) => {
        onPageChange(1);
        onRowCountChange(e.target.value);
    }

    useEffect(() => {
        let cancel = false;
        setHasError(false);
        setIsLoadingContent(true);
        
        // Timeout para evitar carga eterna
        const timeoutId = setTimeout(() => {
          if (!cancel) {
            setGlobalSetting(null);
            setIsLoadingContent(false);
            setHasError(locale === 'en');
          }
        }, 5000);
        
        getGlobal(locale)
          .then((res) => {
            clearTimeout(timeoutId);
            const data = res?.data?.attributes || res?.data || res;
            if (!cancel) {
              setGlobalSetting(data);
              setIsLoadingContent(false);
            }
          })
          .catch((error) => { 
            clearTimeout(timeoutId);
            if (!cancel) {
              setGlobalSetting(null);
              setIsLoadingContent(false);
              setHasError(locale === 'en');
            }
          });
        return () => { 
          cancel = true;
          clearTimeout(timeoutId);
        };
      }, [locale])

    if (isLoadingContent) {
        return (
            <div className="pagination page-title-container">
                <Skeleton.Button style={{ width: 80, height: 40 }} active />
                <Skeleton.Input style={{ width: 120, height: 30 }} active />
                <Skeleton.Button style={{ width: 100, height: 40 }} active />
                <Skeleton.Input style={{ width: 150, height: 40 }} active />
            </div>
        );
    }

    if (hasError && locale === 'en') {
        return <StrapiError 
          onRetry={() => {
            setHasError(false);
            setIsLoadingContent(true);
          }}
          onUseDefault={() => {
            setHasError(false);
            setIsLoadingContent(false);
            setGlobalSetting(null);
          }}
        />
    }

    return (
        <div className="pagination page-title-container">
            <button className="page-button" onClick={handlePrevious} disabled={currentPage === 1}>
                {globalSetting?.before_button ||"Atrás"}
            </button>
            <span>
                {globalSetting?.numberpage ||"Página"} {currentPage} {globalSetting?.page_of ||"de"} {totalPages}
            </span>
            <button className="page-button" onClick={handleNext} disabled={currentPage === totalPages}>
                {globalSetting?.next_button ||"Siguiente"}
            </button>
            <select
                value={`${rowCount}`}
                className="select"
                onChange={handleChangeRowCount}
            >
                <option hidden>Cantidad por página</option>
                <option value={15}>{globalSetting?.filterpage_A ||"15/página"}</option>
                <option value={30}>{globalSetting?.filterpage_B ||"30/página"}</option>
                <option value={50}>{globalSetting?.filterpage_C ||"50/página"}</option>
                <option value={100}>{globalSetting?.filterpage_D ||"100/página"}</option>
            </select>
        </div>
    )
}

export default Pagination